import { Request } from '../request';
import { FormIdentify } from 'types/form';

export const saveIdentification = (params: FormIdentify) => Request.post({
    url: '/schedule-server/provider/profile/personal/identification/save', params });
